import { motion, AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { Separator } from '../data-display/Separator'
import { Icon } from '../icons/Icon'
import Link from '../navigation/Link'
import DrawerNavigator from './DrawerNavigator'
import HeaderTopBanner from './HeaderTopBanner'
import Logo from './Logo'
import PhoneContactLink from './PhoneContactLink'

type Props = {
  isSticky?: boolean
  isActive: (item: { path: string }) => boolean
  showPromoBanner?: boolean
  showBanner?: boolean
  mode?: 'full' | 'banner' | 'main'
  isHome?: boolean
}

export default function HeaderMobile({
  isSticky,
  isActive,
  showBanner = true,
  mode = 'full',
  isHome = false,
}: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const showTopBanner = showBanner && (mode === 'full' || mode === 'banner')
  const showMainHeader = mode === 'full' || mode === 'main'
  const headerVariant = isHome ? 'light' : 'dark'
  const backgroundClass = isHome ? 'bg-primary-800' : 'bg-white'
  const iconColor = isHome ? '#fff' : '#01A8B2'

  return (
    <>
      {showTopBanner && <HeaderTopBanner />}

      {showMainHeader && (
        <header
          className={`
            ${backgroundClass}
            ${isSticky && !isOpen ? `sticky top-0 z-[100]` : ''}
          `}
        >
          <div
            className={`
              flex items-center justify-between

              ${backgroundClass}

              px-4 py-4

              sm:px-14
            `}
          >
            <Icon
              name="basic/menu"
              size="24px"
              className="z-20 cursor-pointer"
              color={iconColor}
              onClick={() => setIsOpen(true)}
            />

            <Logo
              variant={headerVariant}
              className="ml-[28px]"
              iconClassName="h-[28px] w-[180px]"
            />

            <div className="flex items-center gap-3">
              <PhoneContactLink
                variant={headerVariant}
                className="flex items-center"
                iconClassName="cursor-pointer"
              />

              <Link to={'/contacto'}>
                <Icon
                  name="basic/mail"
                  size="20px"
                  className="cursor-pointer"
                  color={iconColor}
                />
              </Link>
            </div>
          </div>
          <div className="px-4">
            <Separator
              className={`!rounded-lg bg-line-gradient-dark opacity-[37%]`}
            />
          </div>
        </header>
      )}

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: '100%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed inset-0 z-[999] flex flex-col bg-white"
            style={{ height: '100dvh' }}
          >
            <DrawerNavigator
              isActive={isActive}
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
